/* Orbit Trends — hero blank guard
 * Keeps poster imagery mounted behind videos. It deliberately does not toggle poster
 * opacity; toggling caused visible flicker on mobile browsers when videos stalled.
 */
(function () {
  'use strict';

  function ensurePoster(panel) {
    var slot = panel && panel.querySelector('[data-orbit-film-slot]');
    if (!slot) return;

    var poster = slot.querySelector('img.orbit-film-hero__poster');
    var video = slot.querySelector('video.orbit-film-hero__video--current') || slot.querySelector('video');
    var posterSrc = (video && (video.getAttribute('poster') || video.poster)) || '';

    if (!poster && posterSrc) {
      poster = document.createElement('img');
      poster.className = 'orbit-film-hero__poster orbit-film-hero__poster--guard';
      poster.alt = '';
      poster.decoding = 'async';
      poster.loading = 'eager';
      poster.src = posterSrc;
      slot.insertBefore(poster, slot.firstChild);
    }

    if (poster) {
      if (!poster.src && posterSrc) poster.src = posterSrc;
      poster.style.opacity = '1';
      poster.style.visibility = 'visible';
    }
  }

  function run() {
    document.querySelectorAll('[data-orbit-film-panel], .orbit-film-hero__panel').forEach(ensurePoster);
  }

  var timer = null;

  function start() {
    run();
    // Only poll on pages that actually render the film hero (and in the editor, where it can be added later)
    var hasHero = document.querySelector('[data-orbit-film-panel], .orbit-film-hero__panel');
    if (!timer && (hasHero || (window.Shopify && window.Shopify.designMode))) timer = window.setInterval(run, 3000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('visibilitychange', run);
  document.addEventListener('shopify:section:load', start);
})();
